import { render, staticRenderFns } from "./record_user_pass.vue?vue&type=template&id=83c9bc44&scoped=true"
import script from "./record_user_pass.vue?vue&type=script&lang=js"
export * from "./record_user_pass.vue?vue&type=script&lang=js"
import style0 from "./record_user_pass.vue?vue&type=style&index=0&id=83c9bc44&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c9bc44",
  null
  
)

export default component.exports